import { VL, lifecycleTone } from './digestVersionI18n';
import { jstDateTime } from '@/utils/jstDate';

export function LifecycleBadge({ v, lang = 'ja', testId }) {
  const L = VL[lang] || VL.ja;
  const life = v.lifecycle || 'candidate';
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold ${lifecycleTone[life] || lifecycleTone.superseded}`}
      data-testid={testId || `digest-version-lifecycle-${v.id}`}>
      {L[life] || life}
    </span>
  );
}

export function VersionMeta({ v, lang = 'ja' }) {
  const L = VL[lang] || VL.ja;
  return (
    <span className="text-[11px] text-zinc-500">
      {L.source[v.source] || v.source}{' · '}{L.reportsN(v.report_count ?? 0)}{' · '}
      {jstDateTime(v.generated_at || v.created_at)}{' · '}{v.generated_by || '—'}
      {v.status === 'complete_with_warnings' && <span className="ml-1 text-amber-700 font-semibold">⚠ {L.warnings}</span>}
      {v.integrity_ok === false && <span className="ml-1 text-rose-700 font-semibold">✖ {L.integrityBad}</span>}
      {v.restored_from_version_number && <span className="ml-1">← v{v.restored_from_version_number}</span>}
    </span>
  );
}
